import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=ed6fbe10&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed6fbe10')) {
      api.createRecord('ed6fbe10', component.options)
    } else {
      api.reload('ed6fbe10', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=ed6fbe10&", function () {
      api.rerender('ed6fbe10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SWvEOW8Z3cw0/JS/comp/ImgFallback2.vue"
export default component.exports